<template>
  <b-card
    v-if="data"
    no-body
    class="card-company-table"
  >
    <b-card-header>
      <b-card-title>Payment Option Success Rate</b-card-title>
    </b-card-header>
    <b-card-body class="statistics-body">

      <b-table
        :items="data"
        responsive
        :fields="fields"
        class="mb-0"
      >
        <!-- company -->
        <template #cell(paymentOptionName)="data">
          <div class="d-flex align-items-center">
            <b-avatar
              rounded
              size="32"
              variant="light-company"
            >
              <b-img
                :src="data.item.imageUrl"
                alt="avatar img"
              /></b-avatar>
            <div>
              <div class="font-weight-bolder">
                {{ data.item.paymentOptionName }}
              </div>
            </div>
          </div>
        </template>

        <!-- category -->
        <template #cell(category)="data">
          <div class="d-flex align-items-center">
            <b-avatar
              class="mr-1"
              :variant="data.item.avatarColor"
            >
              <feather-icon
                size="18"
                :icon="data.item.avatarIcon"
              />
            </b-avatar>
            <span>{{ data.item.avatarTitle }}</span>
          </div>
        </template>

        <!-- sales -->
        <template #cell(successRate)="data">
          <div class="d-flex align-items-center">
            <span class="font-weight-bolder mr-1">{{ data.item.successRate+'%' }}</span>
          </div>
        </template>
      </b-table>
    </b-card-body>

  </b-card>
</template>

<script>
import {
  BCard, BTable, BAvatar, BImg,
  BCardHeader,
  BCardTitle,
  // BCardText,
  BCardBody,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BCardHeader,
    BCardTitle,
    // BCardText,
    BCardBody,
    BAvatar,
    BImg,
  },
  props: {
    data: {
      type: Object,
      default: () => [],
    },
  },

  data() {
    return {
      columns: [
        {
          label: 'Payment Option Name',
          field: 'paymentOptionName',
        },
        {
          label: 'Success Rate',
          field: 'successRate',
        },
      ],
      fields: [
        { key: 'paymentOptionName', label: 'Payment Option Name', visible: true },
        { key: 'successRate', label: 'Success Rate', visible: true },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.card-company-table ::v-deep td .b-avatar.badge-light-company {
  .dark-layout & {
    background: $theme-dark-body-bg !important;
  }
}
</style>
